// campaign()['start']/['end'] starts out as an API date string (from denormalizeCampaign), but
// becomes a real Date once the basics-dates step applies its own edit - both need to parse cleanly
// so re-opening that step (Back) or feeding execution-item-step doesn't silently see null.
export function parseDate(value: unknown): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (!value || typeof value !== 'string') {
    return null;
  }

  const parsed = new Date(value);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
